export const siteMetadata = {
  siteUrl: process.env.SITE_URL || 'https://www.sharesight.com',
  helpUrl: 'https://help.sharesight.com',
  appUrl: 'https://portfolio.sharesight.com',
  communityUrl: 'https://community.sharesight.com',
};

export const testingSiteMetadata = {
  siteUrl: 'https://testing-www.sharesight.com',
  helpUrl: 'https://staging-help.sharesight.com',
  appUrl: 'https://staging-portfolio.sharesight.com/',
  communityUrl: 'https://community.sharesight.com',
};
